@if (loadingText) {
  <div class="loading-text">{{ loadingText }}</div>
}
<div class="loading-overlay">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
